import React from 'react'
import { formatCurrency } from '../utils'

const money = "https://s3.us-east-1.amazonaws.com/docs.blackbaud.services/public/images/money.svg"

const ProgressBar = ({amount, target, percentage}) => {
  const isMobile = window.innerWidth < 600
  const formattedAmount = formatCurrency({
    amount,
    currencyCode: 'GBP',
    locale: 'gb'
  })
  
  const formattedTarget = formatCurrency({
    amount: target,
    currencyCode: 'GBP',
    locale: 'gb'
  })

  const iconStyles = {
    top: isMobile ? -7.5 : -15,
    left: `calc(${percentage < 100 ? percentage : 100}% - ${isMobile ? '20px' : '40px'})`,
    width: isMobile ? '40px' : 'auto',
    height: isMobile ? '40px' : 'auto',
  }
    
  return (
    <div className='container'>
      <div>
        <h2>Fundraising</h2>
        <div className='root'>
          {money && <img src={money} className='icon' style={iconStyles} />}
          <div className='meter'>
            <div style={{ width: `${percentage}%` }} className='fill' />
          </div>
        </div>
        <div className='metrics'>
          <div className='fundraise'>
            Raised:
            <span className='amount'>
              {formattedAmount}
            </span>
          </div>
          <div className='fundraise'>
            Target:
            <span className='amount'>
              {formattedTarget}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProgressBar